<template>
  <div class="nauta-migration-screen-wrapper">
    <div class="nauta-migration-screen-content">
      <div class="nauta-migration-screen-navigation-container">
        <v-icon
          color="#333333"
          size="22"
          @click="$router.go(-1)"
        >
          mdi-arrow-left
        </v-icon>
        <span class="nauta-migration-screen-navigation-help" @click="displayHelpModal = true">
          {{$t('nautaMigration.help')}}
        </span>
      </div>
      <div class="nauta-migration-screen-intro-image">
        <v-img
          :src="require('@/assets/migration/nauta-migration-intro.png')"
          :lazy-src="require('@/assets/migration/nauta-migration-intro-lazy.png')"
          max-width="320"
          contain
        />
      </div>
      <h3 class="nauta-migration-screen-title">
        {{ $t("nautaMigration.title") }}
        <span class="text--secondary" />
      </h3>
      <p class="nauta-migration-screen-description">
        {{ $t("nautaMigration.description") }}
      </p>
      <div class="nauta-migration-screen-download-button">
        <NewButton
          @on-click="displayNautaDownloadModal = true"
          :text="$t('nautaMigration.downloadNauta')"
        />
      </div>
      <div class="nauta-migration-screen-logos-container">
        <v-img
          :src="require('@/assets/migration/mi-dva-logo-android.png')"
          max-width="80"
          contain
        />
        <div class="nauta-migration-screen-logos-arrow">
          <v-icon color="#232323" :size="$vuetify.breakpoint.xs ? 24 : 30">
            mdi-arrow-right-thin
          </v-icon>
        </div>
        <v-img
          :src="require('@/assets/migration/nauta-logo-android.png')"
          contain
          max-width="80"
        />
      </div>
      <h4 class="nauta-migration-screen-about-migration">
        {{ $t("nautaMigration.aboutMigration") }}
      </h4>
      <div class="nauta-migration-screen-statements">
        <div v-for="statement in aboutMigrationStatements" :key="statement.key" class="nauta-migration-screen-statement">
          <div class="nauta-migration-screen-statement-icon-container">
            <v-img
              :src="statement.icon"
              max-width="32"
              contain
            />
          </div>
          <div class="nauta-migration-screen-statement-text-container">
            <h5>
              {{ $t(`nautaMigration.statements.${statement.key}.title`) }}
            </h5>
            <p>
              {{ $t(`nautaMigration.statements.${statement.key}.text`) }}
            </p>
          </div>
        </div>
      </div>
      <h4 class="nauta-migration-screen-faq-title">
        {{ $t("nautaMigration.faq.title") }}
      </h4>
      <div class="nauta-migration-screen-faq-container">
        <div class="nauta-migration-screen-faq" v-for="faqKey in faqKeys" :key="faqKey">
          <a @click="$router.push({ name: 'nautaFaqDetail', params: { faqKey } })">{{ $t(`nautaMigration.faq.${faqKey}.question`) }}</a>
        </div>
      </div>
      <div class="nauta-migration-screen-more-questions-container">
        <h4 class="nauta-migration-screen-more-questions">
          {{ $t("nautaMigration.moreQuestions") }}
        </h4>
        <div class="nauta-migration-screen-more-questions-button-row">
          <div class="nauta-migration-screen-more-questions-button-container">
            <NewButton
              link="https://wa.me/+56982128541"
              :text="$t('nautaMigration.chatUs')"
              icon="mdi-whatsapp"
              class="nauta-migration-screen-whatsapp-button"
            />
          </div>
          <div class="nauta-migration-screen-more-questions-button-container">
            <NewButton
              link="https://tidycal.com/team/equipo-nauta/20-minutos-con-nauta"
              :image="require('@/assets/videocall.png')"
              :text="$t('nautaMigration.bookVideoCall')"
              class="nauta-migration-screen-videocall-button"
            />
          </div>
        </div>
      </div>
    </div>
    <NautaMigrationHelpModal
      id="help-modal"
      :value="displayHelpModal"
      @display="displayHelpModal = $event"
    />
    <NautaDownloadModal
      id="download-modal"
      :value="displayNautaDownloadModal"
      persistent
      @display="displayNautaDownloadModal = $event"
    />
  </div>
</template>

<script>

import NewButton from "@/components/shared/NewButton.vue";
import Verified from "@/assets/migration/verified.svg";
import Widgets from "@/assets/migration/widgets.svg";
import CallSplit from "@/assets/migration/call-split.svg";
import CheckboxBlankCircle from "@/assets/migration/checkbox-blank-circle.svg";
import Stream from "@/assets/migration/stream.svg";
import AccountCircle from "@/assets/migration/account-circle.svg";
import NautaMigrationHelpModal from "@/components/migration/NautaMigrationHelpModal.vue";
import NautaDownloadModal from "@/components/migration/NautaDownloadModal.vue";

export default {
  name: "NautaMigration",

  data: () => ({
    displayHelpModal: false,
    displayNautaDownloadModal: false,
    faqKeys: [
      "reasonForMigration",
      "whatHappensWithMiDVA",
      "differencesBetweenApps",
      "fundsOperation",
      "commissionsSame",
      "contributionWithdrawalTimes",
      "migrationFees",
    ],
  }),

  components: {
    NewButton,
    NautaMigrationHelpModal,
    NautaDownloadModal,
  },

  computed: {
    aboutMigrationStatements() {
      return [
        {
          key: "noImpactOnInvestments",
          icon: Verified,
        },
        {
          key: "organizePortfolios",
          icon: Widgets,
        },
        {
          key: "simplifiedInvestment",
          icon: CallSplit,
        },
        {
          key: "fundAsPortfolio",
          icon: CheckboxBlankCircle,
        },
        {
          key: "personalizedRecommendation",
          icon: Stream,
        },
        {
          key: "parallelApps",
          icon: Verified,
        },
        {
          key: "advisoryMeetings",
          icon: AccountCircle,
        },
      ];
    },

  },

  methods: {
    bookVideoCall() {
      this.$intercom.showNewMessage(
        this.$t("nautaMigration.intercom.bookVideoCall"),
      );
    },

  },

};
</script>

<style lang="scss" scoped>

.nauta-migration-screen-wrapper{
  display: flex;
  justify-content: center;
  margin: 40px 20px;

  @media (max-width: 600px) {
    margin: 30px 20px;

  }
}

.nauta-migration-screen-content {
  max-width: 520px;
  width: 100%;
}

.nauta-migration-screen-intro-image{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 48px;
  margin-bottom: 16px;

  @media (max-width: 960px) {
    margin-top: 32px;
  }
}

.nauta-migration-screen-title {
  font-size: 36px;
  font-weight: 600;
  line-height: 110%;
  letter-spacing: -0.88px;
  color: #333;
  text-align: center;

  @media (max-width: 600px) {
    font-size: 32px;
    text-align: center;
  }
}

p{
  font-size: 16px;
  font-weight: 500;
  line-height: 160%;
  margin: 0cap;
  color: #646363;

  @media (max-width: 600px) {
    font-size: 14px;
  }
}

h4{
  color: #333;
  font-size: 28px;
  line-height: 110%;
  letter-spacing: -0.56px;

  @media (max-width: 600px) {
    font-size: 24px;
  }
}

h5{
  font-size: 20px;
  font-style: normal;
  line-height: 160%;

  @media (max-width: 600px) {
   font-size: 14px;
  }
}

.nauta-migration-screen-description{
  margin-top: 16px;
  text-align: center;
}

.nauta-migration-screen-download-button{
  margin: 48px 0;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 600px) {
    margin: 32px 0;
  }
  > * {
    width: 320px !important;
  }
}

.nauta-migration-screen-logos-container{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0 8px;
  padding-top: 32px;
}

.nauta-migration-screen-about-migration, .nauta-migration-screen-faq-title, .nauta-migration-screen-more-questions{
  text-align: center;
  margin: 24px 0;
  font-weight: 600;
}

.nauta-migration-screen-logos-container > *{
  width: 64px;
  height: 64px;
  max-width: 64px !important;
}

.nauta-migration-screen-logos-arrow{
  background-color: #EDE8FF;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height: 36px;
  width: 36px;

  @media (max-width: 600px) {
    width: 24px;
    height: 24px;
  }
}

.nauta-migration-screen-statements > :last-child{
  border-bottom: none !important;
}

.nauta-migration-screen-statement{
  display: flex;
  align-items: flex-start;
  margin-bottom: 24px;
  gap: 0 18px;
  padding: 32px 0;
  border-bottom: 1px solid #E2E0E0;

  @media (max-width: 600px) {
    gap: 0 12px;
    padding: 24px 0;
  }
}

.nauta-migration-screen-statement-icon-container{
  background-color: #9378FF;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  min-width: 80px;

  @media (max-width: 600px) {
    width: 44px;
    height: 44px;
    min-width: 44px;
  }

}

.nauta-migration-screen-statement-text-container h5{
  font-weight: 600;

}
.nauta-migration-screen-statement-text-container {
  p{
      @media (max-width: 600px) {
      font-size: 12px;
    }
  }
}

.nauta-migration-screen-faq a{
  font-size: 16px;
  line-height: 160%;
  font-weight: 500;
  margin: 8px 0;

  @media (max-width: 600px) {
    font-size: 14px;
  }
}

.nauta-migration-screen-statement-text-container p{
  margin-top: 6px;
}

.nauta-migration-screen-faq-container > :last-child{
  border-bottom: 1px solid #E2E0E0;
}

.nauta-migration-screen-faq{
  padding: 24px 0;
  border-top: 1px solid #E2E0E0;
}

.nauta-migration-screen-faq-container{
  margin-top: 40px;
}

.nauta-migration-screen-more-questions-container{
  padding-top: 48px;
}

.nauta-migration-screen-more-questions-button-row {
  display: flex;
  gap: 10px 20px;
  margin-top: 40px;

  @media (max-width: 600px) {
    margin: 40px;
    flex-direction: column;
  }
}

.nauta-migration-screen-more-questions-button-row > * {
  width: 100% !important;
}

.nauta-migration-screen-more-questions-button-row > :first-child::v-deep .new-btn{
  background-color: #29BA5F !important;
}

.nauta-migration-screen-more-questions-button-row > :last-child::v-deep .new-btn{
  background-color: #313131 !important;
}

.nauta-migration-screen-navigation-container {
  display: flex;
  justify-content: space-between;

  padding: 22px 0;

  @media (max-width: 960px) {
    padding: 0;
  }
}

.nauta-migration-screen-navigation-help{
  font-size: 16px;
  font-weight: 500;
  line-height: 100%;
  color: #646363;

  &:hover{
    cursor: pointer;
  }
}

</style>
